import { setMultipleDesiredAttendeeMuteStatuses } from 'actions/Broadcast';

export default sourcesMuteStatus => dispatch => {
  dispatch(setMultipleDesiredAttendeeMuteStatuses(sourcesMuteStatus));
};
